// extracted by extract-css-chunks-webpack-plugin
module.exports = {"position":"StaticPage-821a998e507fc5a6","wrapper":"StaticPage-2e199947dfe8bc61","prismicContent":"StaticPage-599770692c57b3b7"};